(function() {
  'use strict';

  /* ==========================================================================
     ORW Virtual Trial -- Watch Carousel Engine
     Architecture: Web Animations API (WAAPI) for synchronized motion.
     All watches animate on a single unified timeline. No CSS transitions.
     State: activeIndex is the single source of truth.
     ========================================================================== */

  var section, cards, watchEls, wristZone;
  var activeIndex = 0;
  var isAnimating = false;
  var DURATION = 500;
  var EASING = 'cubic-bezier(0.42, 0, 0.58, 1)'; /* ease-in-out */
  var count = 0;

  /* Offset-to-position map (circular, 4 items) */
  var POS_MAP = ['center', 'right', 'hidden', 'left'];

  /* Explicit transform/opacity for every position state.
     Every watch always has a fully defined state -- no implicit values. */
  var STATES = {
    'center':       { transform: 'translateY(0%) scale(1)',     opacity: 1,   zIndex: 3 },
    'right':        { transform: 'translateY(-70%) scale(0.6)', opacity: 0,   zIndex: 2 },
    'left':         { transform: 'translateY(70%) scale(0.6)',  opacity: 0,   zIndex: 2 },
    'hidden-right': { transform: 'translateY(-140%) scale(0.3)', opacity: 0,  zIndex: 1 },
    'hidden-left':  { transform: 'translateY(140%) scale(0.3)',  opacity: 0,  zIndex: 1 }
  };

  function init() {
    section = document.querySelector('[data-orw-virtual-trial]');
    if (!section) return;

    wristZone = section.querySelector('[data-orw-vt-zone]');
    cards = Array.prototype.slice.call(section.querySelectorAll('[data-orw-vt-card]'));
    watchEls = Array.prototype.slice.call(section.querySelectorAll('[data-orw-vt-wrist]'));
    count = watchEls.length;

    if (count === 0) return;

    /* Set initial resting state */
    activeIndex = 0;
    setRestingState(0);
    updateCards();

    /* Click handlers on thumbnail cards */
    cards.forEach(function(card) {
      card.addEventListener('click', function() {
        if (isAnimating) return;
        var id = card.getAttribute('data-orw-vt-card');
        var idx = findIndex(id);
        if (idx === -1 || idx === activeIndex) return;
        rotateTo(idx);
      });
    });
  }

  function findIndex(watchId) {
    for (var i = 0; i < count; i++) {
      if (watchEls[i].getAttribute('data-orw-vt-wrist') === watchId) return i;
    }
    return -1;
  }

  /* Direction: +1 = forward, -1 = backward (shortest path) */
  function getDirection(targetIdx) {
    var fwd = (targetIdx - activeIndex + count) % count;
    return fwd <= count / 2 ? 1 : -1;
  }

  /* Resolve the position key for a watch index relative to a given active and direction */
  function resolvePosition(watchIdx, refActive, direction) {
    var offset = (watchIdx - refActive + count) % count;
    var pos = POS_MAP[offset];
    if (pos === 'hidden') {
      pos = direction >= 0 ? 'hidden-left' : 'hidden-right';
    }
    return pos;
  }

  /* Set data-pos attributes and clear any inline overrides (resting state) */
  function setRestingState(direction) {
    for (var i = 0; i < count; i++) {
      var pos = resolvePosition(i, activeIndex, direction);
      watchEls[i].setAttribute('data-pos', pos);
      watchEls[i].style.zIndex = '';
    }
  }

  function updateCards() {
    var activeId = watchEls[activeIndex].getAttribute('data-orw-vt-wrist');
    cards.forEach(function(card) {
      card.classList.toggle(
        'orw-virtual-trial__card--active',
        card.getAttribute('data-orw-vt-card') === activeId
      );
    });
  }

  /* ==========================================================================
     rotateTo -- The core animation engine.

     How it works:
     1. Read each watch's ACTUAL current data-pos from the DOM (start state)
     2. Calculate each watch's target position from the new activeIndex
     3. For entering watches (hidden → visible), override start to entry side
     4. Create WAAPI animations for ALL watches simultaneously
     5. Set data-pos to final state immediately (WAAPI overrides CSS during animation)
     6. When ALL animations finish (Promise.all), clear inline styles → CSS takes over

     Why this is glitch-free:
     - WAAPI animations have higher priority than CSS, so data-pos changes never flash
     - All animations share identical duration + easing = perfectly synchronized
     - Promise.all(finished) ensures cleanup happens on the exact frame all animations end
     - No setTimeout, no requestAnimationFrame delays, no class toggling mid-animation
     ========================================================================== */
  function rotateTo(targetIdx) {
    isAnimating = true;
    var direction = getDirection(targetIdx);
    var animations = [];
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var duration = reducedMotion ? 0 : DURATION;

    /* Enable overflow so side watches are visible during motion */
    wristZone.classList.add('orw-virtual-trial__wrist--animating');

    for (var i = 0; i < count; i++) {
      /* Read actual current position from DOM (source of truth for start state) */
      var startPos = watchEls[i].getAttribute('data-pos');

      /* Calculate target position based on new active index */
      var targetPos = resolvePosition(i, targetIdx, direction);

      /* Entering watch: override start to correct entry side.
         Both hidden positions have opacity:0, so the repositioning is invisible. */
      if (startPos.indexOf('hidden') === 0 && targetPos.indexOf('hidden') !== 0) {
        startPos = direction > 0 ? 'hidden-right' : 'hidden-left';
      }

      var startState = STATES[startPos];
      var endState = STATES[targetPos];

      /* Set z-index via inline style for animation period.
         Incoming center watch gets highest z to stay on top throughout. */
      var animZ = Math.max(startState.zIndex, endState.zIndex);
      if (targetPos === 'center') animZ = 4;
      watchEls[i].style.zIndex = animZ;

      /* Create WAAPI animation -- all watches get identical duration + easing */
      var anim = watchEls[i].animate([
        { transform: startState.transform, opacity: startState.opacity },
        { transform: endState.transform,   opacity: endState.opacity }
      ], {
        duration: duration,
        easing: EASING,
        fill: 'none'
      });

      animations.push(anim);
    }

    /* Commit final state to data-pos immediately.
       WAAPI has higher priority than CSS, so these values don't render
       until the animation ends -- then CSS takes over seamlessly. */
    activeIndex = targetIdx;
    setRestingState(direction);
    updateCards();

    /* Clean up when ALL animations complete at the exact same frame */
    Promise.all(animations.map(function(a) { return a.finished; }))
      .then(cleanup)
      .catch(cleanup);

    function cleanup() {
      /* Clear inline z-index -- CSS from data-pos takes over */
      for (var j = 0; j < count; j++) {
        watchEls[j].style.zIndex = '';
      }
      /* Restore overflow clipping */
      wristZone.classList.remove('orw-virtual-trial__wrist--animating');
      isAnimating = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
